import React from 'react'
import {useIntl} from 'react-intl'
import {
    Image,
    Box,
    Button,
    Flex,
    Center,
    useDisclosure,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Link as ChakraLink} from '@chakra-ui/react'
import {ChevronRightIcon} from '@salesforce/retail-react-app/app/components/icons'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import CheckoutDrawer from './checkoutDrawer'
import useLocaleSpecificUrl from '../../../hooks/use-locale-specific-url'
import {useLocation} from 'react-router-dom'

const CheckoutHeader = () => {
    const styles = useMultiStyleConfig('CheckoutHeader')
    const {data: basket} = useCurrentBasket()
    const intl = useIntl()
    const {isOpen, onOpen, onClose} = useDisclosure()
    const homeUrl = useLocaleSpecificUrl('home')
    const orderSection = useLocaleSpecificUrl('order-section')
    const location = useLocation()
    const isConfirmationPage = location.pathname.includes('/confirmation')
    const isErrorPage =
        location.pathname.includes('/error') ||
        location.pathname.includes('/404') ||
        location.pathname.includes('/500')

    return (
        <Box {...styles.wrapper}>
            <Box {...styles.container}>
                <Flex {...styles.stack}>
                    <Link
                        title="Back to homepage"
                        onClick={(e) => {
                            e.preventDefault()
                            window.location.href = homeUrl
                        }}
                        {...styles.mainLogo}
                    >
                        <Image src={getAssetUrl('static/img/Laurastar.webp')} alt="Laurastar" />
                    </Link>

                    {!isErrorPage && !isConfirmationPage && (
                        <Button
                            onClick={onOpen}
                            {...styles.button}
                            rightIcon={
                                <Center {...styles.icon.wrapper}>
                                    <ChevronRightIcon {...styles.icon.right} />
                                </Center>
                            }
                        >
                            {intl.formatMessage({
                                defaultMessage: 'Order Details',
                                id: 'checkout.header.drawer.label'
                            })}
                        </Button>
                    )}

                    {isConfirmationPage && (
                        <Button
                            rightIcon={
                                <Center {...styles.icon.wrapper}>
                                    <ChevronRightIcon {...styles.icon.right} />
                                </Center>
                            }
                            {...styles.confirmbutton}
                        >
                            <ChakraLink href={orderSection} {...styles.confirmbutton.link}>
                                {intl.formatMessage({
                                    defaultMessage: 'Order Details',
                                    id: 'checkout.header.drawer.label'
                                })}
                            </ChakraLink>
                        </Button>
                    )}

                    {!isConfirmationPage && (
                        <CheckoutDrawer isOpen={isOpen} onClose={onClose} basket={basket} />
                    )}
                </Flex>
            </Box>
        </Box>
    )
}

export default CheckoutHeader
